module.exports = "<div>This is the data view.</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/account/data/data.html
// module id = 114
// module chunks = 0